import React from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { sendFeedback } from './searchFeedback.api';
import styles from './feedback_box.module.scss';
import { Connect, PropsFromRedux } from './FeedbackBoxContainer';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';
import { Paper } from '../../../../components/paper/Paper';
import { FeedbackBoxButton } from './FeedbackBoxButton';
import { PrimaryButton } from '../../../../components/button';

export type FeedbackBoxButtonValues = 'YES' | 'NO' | 'PARTIALLY';

type Props = PropsFromRedux & UserContextType;

type State = {
  response: FeedbackBoxButtonValues | null;
  comment: string;
  sent: boolean;
};

export class RawFeedbackBox extends React.Component<Props> {
  state: State = {
    response: null,
    comment: '',
    sent: false,
  };

  sendFeedback = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      const { originalQueryKey } = this.props;
      const { response, comment } = this.state;
      doctrineAnalytics('Search FeedbackFormSent', {
        answer: response,
      });
      if (response && originalQueryKey) {
        await sendFeedback({ response, comment, originalQueryKey });
        this.setState({ sent: true, response: null, comment: '' });
      }
    } catch (error) {
      throw error;
    }
  };

  onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    this.setState({ comment: value });
  };

  selectAnswer = (value: FeedbackBoxButtonValues) => {
    this.setState({ response: value });
  };

  render() {
    const { response, comment, sent } = this.state;
    const { accessPremium } = this.props;

    if (!accessPremium) {
      return null;
    }

    return (
      <Paper level={0} className={styles.card}>
        <div className={styles.title}>
          {sent
            ? `Merci pour votre contribution.`
            : `Donnez votre avis sur le moteur de recherche.`}
        </div>
        {sent ? (
          'Vos retours nous aident à améliorer notre service.'
        ) : (
          <form onSubmit={this.sendFeedback}>
            <div>
              <label className={styles.label}>
                <FormattedMessage id="feedback-box/FeedbackBox.tsx/1" />
              </label>
              <div className={styles.buttons}>
                <FeedbackBoxButton
                  onClick={this.selectAnswer}
                  response={response}
                  value="YES"
                >
                  <FormattedMessage id="feedback-box/FeedbackBox.tsx/2" />
                </FeedbackBoxButton>
                <FeedbackBoxButton
                  onClick={this.selectAnswer}
                  response={response}
                  value="NO"
                >
                  <FormattedMessage id="feedback-box/FeedbackBox.tsx/3" />
                </FeedbackBoxButton>
                <FeedbackBoxButton
                  onClick={this.selectAnswer}
                  response={response}
                  value="PARTIALLY"
                >
                  <FormattedMessage id="feedback-box/FeedbackBox.tsx/4" />
                </FeedbackBoxButton>
              </div>
            </div>
            {response !== null && (
              <div>
                <label className={styles.label}>
                  {response === 'YES' && (
                    <FormattedMessage id="feedback-box/FeedbackBox.tsx/6" />
                  )}
                  {response !== 'YES' && (
                    <FormattedMessage id="feedback-box/FeedbackBox.tsx/7" />
                  )}
                </label>
                <textarea
                  className={styles.textarea}
                  rows={3}
                  value={comment}
                  onChange={this.onChange}
                />
                <PrimaryButton type="submit">
                  <FormattedMessage id="feedback-box/FeedbackBox.tsx/5" />
                </PrimaryButton>
              </div>
            )}
          </form>
        )}
      </Paper>
    );
  }
}

export const FeedbackBox = withUser(Connect(RawFeedbackBox));
